var map = {
	"./symbol_0.png": 28972,
	"./symbol_1.png": 11861,
	"./symbol_2.png": 26110,
	"./symbol_3.png": 97447,
	"./symbol_4.png": 22280,
	"./symbol_5.png": 62225,
	"./symbol_6.png": 53914,
	"./symbol_7.png": 59139,
	"./symbol_8.png": 15268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65415;